import * as fromCalendarWidget from './calendar-widget.reducer';
import {Action, combineReducers, createFeatureSelector, createSelector} from '@ngrx/store';

export const calendarFeatureKey = 'calendar';

export interface CalendarState {
  [fromCalendarWidget.calendarWidgetKey]: fromCalendarWidget.State;
}

export interface State {
  [calendarFeatureKey]: CalendarState;
}

export function reducers(state: CalendarState | undefined, action: Action): CalendarState {
  return combineReducers({
    [fromCalendarWidget.calendarWidgetKey]: fromCalendarWidget.reducer,
  })(state, action);
}

export const selectCalendarState = createFeatureSelector< CalendarState>(
  calendarFeatureKey
);

export const selectCalendarWidgetState = createSelector(
  selectCalendarState,
  (state) => state[fromCalendarWidget.calendarWidgetKey]
);

export const selectCalendarWidgetInitialingState = createSelector(
  selectCalendarWidgetState,
  (state) => state.isInitialing
);

export const selectCalendarWidgetSelectedTimeState = createSelector(
  selectCalendarWidgetState,
  (state) => state.selectedTime
);

export const selectCalendarWidgetHostIdState = createSelector(
  selectCalendarWidgetState,
  (state) => state.hostId
);

export const selectCalendarWidgetSellerAvailabilityState = createSelector(
  selectCalendarWidgetState,
  (state) => ({
    isHostedBySeller: state.isHostedBySeller,
    selectedDate: state.selectedDate,
    sellerAvailability: state.sellerAvailability
  })
);

export const selectCalendarWidgetIsLoadingDistanceState = createSelector(
  selectCalendarWidgetState,
  (state) => state.isLoadingDistance
);
